import {
  DefaultActionsErrorView,
  ErrorBoundary,
  LoaderCentered,
} from '@modules/components';
import RemoteAdCreator from '@modules/remotes/adcreator';
import { Suspense } from 'react';
import { useMfCreatorConfig } from './useMfAdCreatorConfig';

function AdmModuleAdCreator() {
  const config = useMfCreatorConfig();

  return (
    <ErrorBoundary fallback={<DefaultActionsErrorView />}>
      <Suspense fallback={<LoaderCentered />}>
        <RemoteAdCreator {...config} />
      </Suspense>
    </ErrorBoundary>
  );
}

export default AdmModuleAdCreator;
